var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._t("default"),_vm._v(" "),(_vm.hasError)?_c('b',{class:{
              'has-error':_vm.hasError
          }},[_vm._v(_vm._s(_vm.message))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8db4eda4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/test/P.vue
// module id = 164
// module chunks = 0